(() => {
  'use strict';

  const config = document.querySelector('[data-bm-codemotion-config]');
  const template = document.getElementById('BMCodemotionCheckoutTemplate');

  if (!config || !template) return;

  const allowedCodes = new Set(['BIZZY-CODEMOTION-100', 'BIZZY-CODEMOTION-75']);
  const targetVariantId = Number(config.dataset.targetVariantId);
  const rootUrl = config.dataset.rootUrl.endsWith('/') ? config.dataset.rootUrl : `${config.dataset.rootUrl}/`;
  const state = {
    code: normalizeCode(config.dataset.initialCode || new URLSearchParams(window.location.search).get('codemotion') || ''),
    ticket: String(config.dataset.initialTicket || '').trim(),
  };

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function validTicket(value) {
    const ticket = String(value || '').trim();
    return ticket.length >= 3 && ticket.length <= 100 && !/[\u0000-\u001F\u007F]/.test(ticket);
  }

  function eligibleCart(cart) {
    return Boolean(
      cart &&
        Array.isArray(cart.items) &&
        cart.items.length === 1 &&
        Number(cart.items[0]?.variant_id) === targetVariantId &&
        Number(cart.items[0]?.quantity) === 1
    );
  }

  function setStatus(root, message, kind = '') {
    const status = root.querySelector('[data-bm-codemotion-status]');
    status.textContent = message;
    status.dataset.kind = kind;
  }

  function setBusy(root, busy) {
    root.querySelectorAll('input, button').forEach((element) => {
      element.disabled = busy;
    });
    root.setAttribute('aria-busy', String(busy));
  }

  function setCampaignActive() {
    document.documentElement.classList.toggle('bm-codemotion-active', Boolean(state.code || state.ticket));
  }

  function syncForms(source) {
    document.querySelectorAll('[data-bm-codemotion-form]').forEach((form) => {
      if (form === source) return;
      form.elements.codemotion_code.value = state.code;
      form.elements.codemotion_ticket.value = state.ticket;
    });
  }

  async function updateAttributes(attributes) {
    const response = await fetch(config.dataset.cartUpdateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) throw new Error('cart_update_failed');
    return response.json();
  }

  async function submitCodemotion(form) {
    const root = form.closest('[data-bm-codemotion-root]');
    const codeInput = form.elements.codemotion_code;
    const ticketInput = form.elements.codemotion_ticket;
    state.code = normalizeCode(codeInput.value);
    state.ticket = String(ticketInput.value || '').trim();
    codeInput.value = state.code;
    ticketInput.value = state.ticket;
    syncForms(form);

    if (!allowedCodes.has(state.code)) {
      codeInput.setCustomValidity(config.dataset.invalidCodeMessage);
      codeInput.reportValidity();
      setStatus(root, config.dataset.invalidCodeMessage, 'error');
      return;
    }
    codeInput.setCustomValidity('');

    if (!validTicket(state.ticket)) {
      ticketInput.setCustomValidity(config.dataset.invalidTicketMessage);
      ticketInput.reportValidity();
      setStatus(root, config.dataset.invalidTicketMessage, 'error');
      return;
    }
    ticketInput.setCustomValidity('');
    setBusy(root, true);
    setStatus(root, config.dataset.savingMessage, 'loading');

    try {
      const cartResponse = await fetch(config.dataset.cartJsonUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) throw new Error('cart_read_failed');
      const cart = await cartResponse.json();
      if (!eligibleCart(cart)) {
        setStatus(root, config.dataset.invalidCartMessage, 'error');
        setBusy(root, false);
        return;
      }

      await updateAttributes({
        'Codemotion coupon': state.code,
        'Codemotion ticket': state.ticket,
        'Codemotion fulfillment': 'RITIRO IN FIERA',
      });

      const checkoutPath = `${rootUrl}checkout`;
      const redirect = `${rootUrl}discount/${encodeURIComponent(state.code)}?redirect=${encodeURIComponent(checkoutPath)}`;
      window.location.assign(redirect);
    } catch (error) {
      console.error('BizzyMagic Codemotion checkout:', error);
      setStatus(root, config.dataset.networkMessage, 'error');
      setBusy(root, false);
    }
  }

  async function resetCodemotion(form) {
    const root = form.closest('[data-bm-codemotion-root]');
    setBusy(root, true);
    try {
      await updateAttributes({
        'Codemotion coupon': '',
        'Codemotion ticket': '',
        'Codemotion fulfillment': '',
      });
      state.code = '';
      state.ticket = '';
      form.reset();
      syncForms(form);
      setCampaignActive();
      setStatus(root, config.dataset.clearedMessage, 'success');
    } catch (error) {
      console.error('BizzyMagic Codemotion reset:', error);
      setStatus(root, config.dataset.networkMessage, 'error');
    } finally {
      setBusy(root, false);
    }
  }

  function mountBeforeCheckout(button) {
    const ctas = button.closest('.cart__ctas');
    if (!ctas || ctas.previousElementSibling?.matches('[data-bm-codemotion-root]')) return;

    const fragment = template.content.cloneNode(true);
    const root = fragment.querySelector('[data-bm-codemotion-root]');
    const form = root.querySelector('[data-bm-codemotion-form]');
    const suffix = button.id === 'CartDrawer-Checkout' ? 'Drawer' : 'Page';
    const codeInput = form.elements.codemotion_code;
    const ticketInput = form.elements.codemotion_ticket;
    codeInput.id = `BMCodemotionCode${suffix}`;
    ticketInput.id = `BMCodemotionTicket${suffix}`;
    form.querySelector('label[for="BMCodemotionCode"]').htmlFor = codeInput.id;
    form.querySelector('label[for="BMCodemotionTicket"]').htmlFor = ticketInput.id;
    form.elements.codemotion_code.value = state.code;
    form.elements.codemotion_ticket.value = state.ticket;
    root.open = Boolean(state.code || state.ticket);
    form.addEventListener('input', () => {
      state.code = normalizeCode(form.elements.codemotion_code.value);
      state.ticket = String(form.elements.codemotion_ticket.value || '').trim();
      syncForms(form);
      setCampaignActive();
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submitCodemotion(form);
    });
    form.querySelector('[data-bm-codemotion-reset]').addEventListener('click', () => resetCodemotion(form));
    ctas.before(fragment);
  }

  function mountAll() {
    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach(mountBeforeCheckout);
  }

  document.addEventListener(
    'click',
    (event) => {
      const checkout = event.target.closest('#checkout, #CartDrawer-Checkout');
      if (!checkout) return;
      const root = checkout.closest('.cart__blocks, .drawer__footer')?.querySelector('[data-bm-codemotion-root]');
      const form = root?.querySelector('[data-bm-codemotion-form]');
      if (!form) return;

      const code = normalizeCode(form.elements.codemotion_code.value);
      const ticket = String(form.elements.codemotion_ticket.value || '').trim();
      if (!code && !ticket) return;

      event.preventDefault();
      event.stopPropagation();
      form.requestSubmit();
    },
    true
  );

  const observer = new MutationObserver(mountAll);
  observer.observe(document.body, { childList: true, subtree: true });
  setCampaignActive();
  mountAll();
})();
